var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { call, put, takeEvery } from 'redux-saga/effects';
import { assign, pick } from 'lodash';
import { load } from '../loaders';
import * as actions from '../actions';
import { TypesManager } from '../type';
import { behaviorHandle, errorHandle } from '../services';
/**
 * 在页面启动时调用的saga，此时为切换分页至第一页
 */

export function initEntitySagas() {
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        return [4
        /*yield*/
        , takeEvery(actions.SEARCH, searchSaga)];

      case 1:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.LOAD_NEXT_PAGE, loadNextPageSaga)];

      case 2:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.ADD, addSaga)];

      case 3:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.DELETE, deleteSaga)];

      case 4:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.GET, getSaga)];

      case 5:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.MODIFY, modifySaga)];

      case 6:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.LOAD_PROPERTY_OPTIONS, loadPropertyOptionsSaga)];

      case 7:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.LOAD_FILTER_OPTIONS, loadFilterOptionsSaga)];

      case 8:
        _a.sent();

        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> searchSaga 搜索saga
 */

function searchSaga(action) {
  var method, entity, params, successBehavior, errorBehavior, data, paging, filters, _a, apiPath, apiRoot, paramsFilter, types, response, e_1;

  return __generator(this, function (_b) {
    switch (_b.label) {
      case 0:
        method = 'get';
        entity = action.entity, params = action.params, successBehavior = action.successBehavior, errorBehavior = action.errorBehavior;
        _b.label = 1;

      case 1:
        _b.trys.push([1, 4,, 6]);

        paging = entity.paging, filters = entity.filters;
        _a = entity.metainfo, apiPath = _a.apiPath, apiRoot = _a.apiRoot, paramsFilter = _a.paramsFilter, types = _a.filters;
        data = {
          apiRoot: apiRoot,
          apiPath: apiPath,
          paramsFilter: paramsFilter,
          params: assign({}, params, TypesManager.formatParams(types, filters), pick(paging, ['page', 'perPage']))
        };
        return [4
        /*yield*/
        , call(load, method, data)];

      case 2:
        response = _b.sent();
        return [4
        /*yield*/
        , put(actions.searchSuccessAction(entity, response))];

      case 3:
        _b.sent();

        if (Object.prototype.toString.call(successBehavior) === '[object Object]') {
          behaviorHandle(successBehavior);
        }

        return [3
        /*break*/
        , 6];

      case 4:
        e_1 = _b.sent();

        if (Object.prototype.toString.call(errorBehavior) === '[object Object]') {
          behaviorHandle(errorBehavior);
        }

        errorHandle(e_1);
        return [4
        /*yield*/
        , put(actions.searchFailedAction(entity, {
          request: data,
          message: e_1.message,
          statusCode: e_1.statusCode,
          status: e_1.status,
          stack: e_1.stack
        }))];

      case 5:
        _b.sent();

        return [3
        /*break*/
        , 6];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> 加载下一页数据 saga
 */


function loadNextPageSaga(action) {
  var method, entity, params, successBehavior, errorBehavior, data, _a, page, perPage, filters, _b, apiPath, apiRoot, paramsFilter, types, response, e_2;

  return __generator(this, function (_c) {
    switch (_c.label) {
      case 0:
        method = 'get';
        entity = action.entity, params = action.params, successBehavior = action.successBehavior, errorBehavior = action.errorBehavior;
        _c.label = 1;

      case 1:
        _c.trys.push([1, 4,, 6]);

        _a = entity.paging, page = _a.page, perPage = _a.perPage, filters = entity.filters;
        _b = entity.metainfo, apiPath = _b.apiPath, apiRoot = _b.apiRoot, paramsFilter = _b.paramsFilter, types = _b.filters;
        data = {
          apiRoot: apiRoot,
          apiPath: apiPath,
          paramsFilter: paramsFilter,
          params: assign({}, params, TypesManager.formatParams(types, filters), {
            page: page + 1,
            perPage: perPage
          })
        };
        return [4
        /*yield*/
        , call(load, method, data)];

      case 2:
        response = _c.sent();
        return [4
        /*yield*/
        , put(actions.loadNextPageSuccessAction(entity, response))];

      case 3:
        _c.sent();

        if (Object.prototype.toString.call(successBehavior) === '[object Object]') {
          behaviorHandle(successBehavior);
        }

        return [3
        /*break*/
        , 6];

      case 4:
        e_2 = _c.sent();

        if (Object.prototype.toString.call(errorBehavior) === '[object Object]') {
          behaviorHandle(errorBehavior);
        }

        errorHandle(e_2);
        return [4
        /*yield*/
        , put(actions.loadNextPageFailedAction(entity, {
          request: data,
          message: e_2.message,
          statusCode: e_2.statusCode,
          status: e_2.status,
          stack: e_2.stack
        }))];

      case 5:
        _c.sent();

        return [3
        /*break*/
        , 6];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> addSaga 添加saga
 */


function addSaga(action) {
  var method, entity, params, fields, successBehavior, errorBehavior, data, _a, apiPath, apiRoot, paramsFilter, types, response, e_3;

  return __generator(this, function (_b) {
    switch (_b.label) {
      case 0:
        method = 'post';
        entity = action.entity, params = action.params, fields = action.fields, successBehavior = action.successBehavior, errorBehavior = action.errorBehavior;
        _b.label = 1;

      case 1:
        _b.trys.push([1, 4,, 6]);

        _a = entity.metainfo, apiPath = _a.apiPath, apiRoot = _a.apiRoot, paramsFilter = _a.paramsFilter, types = _a.properties;
        data = {
          apiRoot: apiRoot,
          apiPath: apiPath,
          paramsFilter: paramsFilter,
          params: assign({}, params, TypesManager.formatParams(types, fields))
        };
        return [4
        /*yield*/
        , call(load, method, data)];

      case 2:
        response = _b.sent();
        return [4
        /*yield*/
        , put(actions.addSuccessAction(entity, response))];

      case 3:
        _b.sent();

        if (Object.prototype.toString.call(successBehavior) === '[object Object]') {
          behaviorHandle(successBehavior);
        }

        return [3
        /*break*/
        , 6];

      case 4:
        e_3 = _b.sent();

        if (Object.prototype.toString.call(errorBehavior) === '[object Object]') {
          behaviorHandle(errorBehavior);
        }

        errorHandle(e_3);
        return [4
        /*yield*/
        , put(actions.addFailedAction(entity, {
          request: data,
          message: e_3.message,
          statusCode: e_3.statusCode,
          status: e_3.status,
          stack: e_3.stack
        }))];

      case 5:
        _b.sent();

        return [3
        /*break*/
        , 6];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> deleteSaga 删除saga
 */


function deleteSaga(action) {
  var method, params, entity, successBehavior, errorBehavior, data, apiPath, _a, apiRoot, paramsFilter, e_4;

  return __generator(this, function (_b) {
    switch (_b.label) {
      case 0:
        method = 'delete';
        params = action.params, entity = action.entity, successBehavior = action.successBehavior, errorBehavior = action.errorBehavior;
        _b.label = 1;

      case 1:
        _b.trys.push([1, 4,, 6]);

        apiPath = entity.metainfo.apiPath;

        if (params.id && !/\/:id/.test(entity.metainfo.apiPath)) {
          apiPath += '/:id';
        }

        _a = entity.metainfo, apiRoot = _a.apiRoot, paramsFilter = _a.paramsFilter;
        data = {
          apiRoot: apiRoot,
          apiPath: apiPath,
          paramsFilter: paramsFilter,
          params: params
        };
        return [4
        /*yield*/
        , call(load, method, data)];

      case 2:
        _b.sent();

        return [4
        /*yield*/
        , put(actions.deleteSuccessAction(entity))];

      case 3:
        _b.sent();

        if (Object.prototype.toString.call(successBehavior) === '[object Object]') {
          behaviorHandle(successBehavior);
        }

        return [3
        /*break*/
        , 6];

      case 4:
        e_4 = _b.sent();

        if (Object.prototype.toString.call(errorBehavior) === '[object Object]') {
          behaviorHandle(errorBehavior);
        }

        errorHandle(e_4);
        return [4
        /*yield*/
        , put(actions.deleteFailedAction(entity, {
          request: data,
          message: e_4.message,
          statusCode: e_4.statusCode,
          status: e_4.status,
          stack: e_4.stack
        }))];

      case 5:
        _b.sent();

        return [3
        /*break*/
        , 6];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> getSaga 获取单条数据saga
 */


function getSaga(action) {
  var method, params, entity, successBehavior, errorBehavior, data, apiPath, _a, apiRoot, paramsFilter, fields, e_5;

  return __generator(this, function (_b) {
    switch (_b.label) {
      case 0:
        method = 'get';
        params = action.params, entity = action.entity, successBehavior = action.successBehavior, errorBehavior = action.errorBehavior;
        _b.label = 1;

      case 1:
        _b.trys.push([1, 4,, 6]);

        apiPath = entity.metainfo.apiPath;

        if (params.id && !/\/:id/.test(entity.metainfo.apiPath)) {
          apiPath += '/:id';
        }

        _a = entity.metainfo, apiRoot = _a.apiRoot, paramsFilter = _a.paramsFilter;
        data = {
          apiRoot: apiRoot,
          apiPath: apiPath,
          paramsFilter: paramsFilter,
          params: params
        };
        return [4
        /*yield*/
        , call(load, method, data)];

      case 2:
        fields = _b.sent();
        return [4
        /*yield*/
        , put(actions.getSuccessAction(entity, fields))];

      case 3:
        _b.sent();

        if (Object.prototype.toString.call(successBehavior) === '[object Object]') {
          behaviorHandle(successBehavior);
        }

        return [3
        /*break*/
        , 6];

      case 4:
        e_5 = _b.sent();

        if (Object.prototype.toString.call(errorBehavior) === '[object Object]') {
          behaviorHandle(errorBehavior);
        }

        errorHandle(e_5);
        return [4
        /*yield*/
        , put(actions.getFailedAction(entity, {
          request: data,
          message: e_5.message,
          statusCode: e_5.statusCode,
          status: e_5.status,
          stack: e_5.stack
        }))];

      case 5:
        _b.sent();

        return [3
        /*break*/
        , 6];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> modifySaga 修改saga
 */


function modifySaga(action) {
  var method, entity, params, fields, successBehavior, errorBehavior, data, metainfo, apiRoot, paramsFilter, types, apiPath, e_6;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        method = 'put';
        entity = action.entity, params = action.params, fields = action.fields, successBehavior = action.successBehavior, errorBehavior = action.errorBehavior;
        _a.label = 1;

      case 1:
        _a.trys.push([1, 4,, 6]);

        metainfo = entity.metainfo;
        apiRoot = metainfo.apiRoot, paramsFilter = metainfo.paramsFilter, types = metainfo.properties;
        apiPath = entity.metainfo.apiPath;

        if (params.id && !/\/:id/.test(entity.metainfo.apiPath)) {
          apiPath += '/:id';
        }

        data = {
          apiRoot: apiRoot,
          apiPath: apiPath,
          paramsFilter: paramsFilter,
          params: assign({}, params, TypesManager.formatParams(types, fields))
        };
        return [4
        /*yield*/
        , call(load, method, data)];

      case 2:
        _a.sent();

        return [4
        /*yield*/
        , put(actions.modifySuccessAction(entity))];

      case 3:
        _a.sent();

        if (Object.prototype.toString.call(successBehavior) === '[object Object]') {
          behaviorHandle(successBehavior);
        }

        return [3
        /*break*/
        , 6];

      case 4:
        e_6 = _a.sent();

        if (Object.prototype.toString.call(errorBehavior) === '[object Object]') {
          behaviorHandle(errorBehavior);
        }

        errorHandle(e_6);
        return [4
        /*yield*/
        , put(actions.modifyFailedAction(entity, {
          request: data,
          message: e_6.message,
          statusCode: e_6.statusCode,
          status: e_6.status,
          stack: e_6.stack
        }))];

      case 5:
        _a.sent();

        return [3
        /*break*/
        , 6];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}

function loadPropertyOptionsSaga(action) {
  var method, entity, fieldName, source, response, e_7;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        method = 'get';
        entity = action.entity, fieldName = action.fieldName, source = action.source;

        if (source && !source.params) {
          source.params = {};
        }

        _a.label = 1;

      case 1:
        _a.trys.push([1, 4,, 6]);

        return [4
        /*yield*/
        , call(load, method, source)];

      case 2:
        response = _a.sent();
        return [4
        /*yield*/
        , put(actions.loadPropertyOptionsSuccessAction(entity, fieldName, response))];

      case 3:
        _a.sent();

        return [3
        /*break*/
        , 6];

      case 4:
        e_7 = _a.sent();
        errorHandle(e_7);
        return [4
        /*yield*/
        , put(actions.loadPropertyOptionsFailedAction(entity, {
          fieldName: fieldName,
          request: source,
          message: e_7.message,
          statusCode: e_7.statusCode,
          status: e_7.status,
          stack: e_7.stack
        }))];

      case 5:
        _a.sent();

        return [3
        /*break*/
        , 6];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}

function loadFilterOptionsSaga(action) {
  var method, entity, fieldName, source, response, e_8;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        method = 'get';
        entity = action.entity, fieldName = action.fieldName, source = action.source;

        if (source && !source.params) {
          source.params = {};
        }

        _a.label = 1;

      case 1:
        _a.trys.push([1, 4,, 6]);

        return [4
        /*yield*/
        , call(load, method, source)];

      case 2:
        response = _a.sent();
        return [4
        /*yield*/
        , put(actions.loadFilterOptionsSuccessAction(entity, fieldName, response))];

      case 3:
        _a.sent();

        return [3
        /*break*/
        , 6];

      case 4:
        e_8 = _a.sent();
        errorHandle(e_8);
        return [4
        /*yield*/
        , put(actions.loadFilterOptionsFailedAction(entity, {
          fieldName: fieldName,
          request: source,
          message: e_8.message,
          statusCode: e_8.statusCode,
          status: e_8.status,
          stack: e_8.stack
        }))];

      case 5:
        _a.sent();

        return [3
        /*break*/
        , 6];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}